jQuery(function ($) { popupinit($); });
jQuery(document).on('js_event_wpv_pagination_completed', popupinit);
jQuery(document).on('js_event_wpv_parametric_search_results_updated', popupinit);
function popupinit($) {
    jQuery('.fff-productGallery').each(function () {
        jQuery(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true
            },
            callbacks: {
                open: function () {
                    $(this.content).append('<p class="zoomPopup"></p>');
                    $('.zoomPopup').on('click', function () {
                        $(this).toggleClass('-zoomed');
                        $(this).siblings().find('img').toggleClass('-zoomed');
                        $(this).parent().parent().toggleClass('-zoomed');
                    });
                    $('.mfp-arrow').on('click', () => {
                        $(this.container).find('.-zoomed').removeClass('-zoomed');
                    });
                }
            }
        });
    });
}
